import { render, staticRenderFns } from "./StepCustomization.vue?vue&type=template&id=79c94d2b&scoped=true&"
import script from "./StepCustomization.vue?vue&type=script&lang=js&"
export * from "./StepCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c94d2b",
  null
  
)

export default component.exports